module.exports = __webpack_public_path__ + "img/email-logo.d6701f76.png";